import { useSelector } from 'react-redux';

import { welcomeOfferHvcSelector } from '@/domains/proB2BServices/platformConfig/platformConfig.selectors';

export const useLoyaltyProgramHvcWelcomeOffer = () => {
  const welcomeOffer = useSelector(welcomeOfferHvcSelector);

  if (!welcomeOffer) return null;

  return welcomeOffer.amount;
};
